import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { PayoutReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: PayoutReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    statuses: report.statuses,
    operationIds: report.operationIds
  }
});
